import React from 'react';
import { calculateZusatzoptionenpreisJeKulisse } from '../calculations/pricing';

class ZusatzoptionenPreis extends React.Component {

    // daten = [];
    // datastring = '';
    getDaten(){

        let d = calculateZusatzoptionenpreisJeKulisse({
            KulissenpreisNetto: this.props.KulissenpreisNetto,
            Rabatt: this.props.Rabatt,
            Optionen: this.props.Optionen,
            Kulissenbreite: this.props.Kulissenbreite,
            Kulissenlaenge: this.props.Kulissenlaenge,
            Kulissenhoehe: this.props.Kulissenhoehe,
        });
        this.props.ZusatzoptionenpreisChange(d);

        // this.props.KulissenpreisChange(d);
        return d;
    }



    render() {
        // console.log("Datenlänge: "+this.state.daten.length);
        this.getDaten();
        return <></>;

        // return (
        //     <>
        //          {/*<td>{this.getDeltaWert(this.props.Einfuegedaempfungsdaten ,xSoll,ySoll,Xname,Yname,'250')}</td>*/}
        //         {/*<td>{this.getDaten("Preis").toFixed(2)}</td>*/}
        //         {/* <td>{this.getDaten("63").toFixed(2)}</td>*/}
        //         {/*<td>{this.getDaten("125").toFixed(2)}</td>*/}
        //         {/*<td>{this.getDaten("250").toFixed(2)}</td>*/}
        //         {/*<td>{this.getDaten("500").toFixed(2)}</td>*/}
        //         {/*<td>{this.getDaten("1000").toFixed(2)}</td>*/}
        //         {/*<td>{this.getDaten("2000").toFixed(2)}</td>*/}
        //         {/*<td>{this.getDaten("4000").toFixed(2)}</td>*/}
        //         {/*<td>{this.getDaten("8000").toFixed(2)}</td>*/}
        //
        //     </>);


    }
}
export default ZusatzoptionenPreis ;
